var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidGroupNlp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 15,
    viewBox: "0 0 47 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5326",
    "data-name": "Group 5326",
    transform: "translate(10462 22029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    transform: "translate(-10462 -22029)",
    fill: "none",
    stroke: "#c50303",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 15,
    rx: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 14,
    rx: 7,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Android",
    transform: "translate(-10454 -22018)",
    fill: "#c50303",
    fontSize: 8,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Android")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidGroupNlp);
export default __webpack_public_path__ + "static/media/Android_GroupNLP.a79a5e21e217176ee5ef5d785b3f6b18.svg";
export { ForwardRef as ReactComponent };